export default [
  {
    lang: 'ar_SA',
    name: 'العربية',
    countryCode: 'SA',
    browserLanguageCode:'ar',
  },
  {
    lang: 'da_DK',
    name: 'Dansk',
    countryCode: 'DK',
    browserLanguageCode:'da',
  },
  {
    lang: 'en_GB',
    name: 'English (United Kingdom)',
    countryCode: 'GB',
    browserLanguageCode:'en-GB',
  },
  {
    lang: 'en_US',
    name: 'English (United States)',
    countryCode: 'US',
    browserLanguageCode:'en-US',
  },
  {
    lang: 'es_BO',
    name: 'Español (Latinoamérica)',
    countryCode: 'BO',
    browserLanguageCode:'es-419',
  },
  {
    lang: 'es_ES',
    name: 'Español (España)',
    countryCode: 'ES',
    browserLanguageCode:'es',
  },
  {
    lang: 'fi_FI',
    name: 'Suomi',
    countryCode: 'FI',
    browserLanguageCode:'fi',
  },
  {
    lang: 'fr_CA',
    name: 'Français (Canada)',
    countryCode: 'CA',
    browserLanguageCode:'fr-CA'
  },
  {
    lang: 'fr_FR',
    name: 'Français (France)',
    countryCode: 'FR',
    browserLanguageCode:'fr-FR'
  },
  {
    lang: 'de_DE',
    name: 'Deutsch',
    countryCode: 'DE',
    browserLanguageCode:'de-DE'
  },
  {
    lang: 'el_GR',
    name: 'Ελληνικά',
    countryCode: 'GR',
    browserLanguageCode:'el',
  },
  {
    lang: 'ht_HT',
    name: 'Kreyòl Ayisyen',
    countryCode: 'HT',
    browserLanguageCode:'ht'
  },
  {
    lang: 'id_ID',
    name: 'Bahasa Indonesia',
    countryCode: 'ID',
    browserLanguageCode:'id'
  },
  {
    lang: 'it_IT',
    name: 'Italiano',
    countryCode: 'IT',
    browserLanguageCode:'it'
  },
  {
    lang: 'ja_JP',
    name: '日本語',
    countryCode: 'JP',
    browserLanguageCode:'ja'
  },
  {
    lang: 'ko_KR',
    name: '한국어',
    countryCode: 'KR',
    browserLanguageCode:'ko'
  },
  {
    lang: 'nl_NL',
    name: 'Nederlands',
    countryCode: 'NL',
    browserLanguageCode:'nl'
  },
  {
    lang: 'no_NO',
    name: 'Norsk',
    countryCode: 'NO',
    browserLanguageCode:'no'
  },
  {
    lang: 'pt_BR',
    name: 'Português (Brasil)',
    countryCode: 'BR',
    browserLanguageCode:'pt-BR'
  },
  {
    lang: 'pt_PT',
    name: 'Português (Portugal)',
    countryCode: 'PT',
    browserLanguageCode:'pt'
  },
  {
    lang: 'ru_RU',
    name: 'Русский',
    countryCode: 'RU',
    browserLanguageCode:'ru'
  },
  {
    lang: 'sv_SE',
    name: 'Svenska',
    countryCode: 'SE',
    browserLanguageCode:'sv'
  },
  {
    lang: 'zh_CN',
    name: '中文 (简体)',
    countryCode: 'CN',
    browserLanguageCode:'zh-CN'
  },
  {
    lang: 'zh_TW',
    name: '中文 (繁體)',
    countryCode: 'TW',
    browserLanguageCode:'tw'
  },
  {
    lang: 'tr_TR',
    name: 'Türkçe',
    countryCode: 'TR',
    browserLanguageCode:'tr'
  },
  {
    lang: 'th_TH',
    name: 'ไทย',
    countryCode: 'TH',
    browserLanguageCode:'th'
  },
  {
    lang: 'vi_VN',
    name: 'Tiếng Việt',
    countryCode: 'VN',
    browserLanguageCode:'vi'
  },
];